var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCirclePlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.9773C0 7.15328 7.15328 0 15.9773 0C24.797 0.0104049 31.9442 7.1576 31.9546 15.9773C31.9546 24.8013 24.8013 31.9546 15.9773 31.9546C7.15328 31.9546 0 24.8013 0 15.9773ZM2.90496 15.9773C2.90496 23.197 8.75765 29.0496 15.9773 29.0496C23.1933 29.0408 29.0408 23.1933 29.0496 15.9773C29.0496 8.75765 23.197 2.90496 15.9773 2.90496C8.75765 2.90496 2.90496 8.75765 2.90496 15.9773Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M23.2395 14.528H17.4296V8.71811C17.4296 7.91592 16.7793 7.26562 15.9771 7.26562C15.1749 7.26562 14.5246 7.91592 14.5246 8.71811V14.528H8.71469C7.91251 14.528 7.26221 15.1783 7.26221 15.9805C7.26221 16.7827 7.91251 17.433 8.71469 17.433H14.5246V23.2429C14.5246 24.0451 15.1749 24.6954 15.9771 24.6954C16.7793 24.6954 17.4296 24.0451 17.4296 23.2429V17.433H23.2395C24.0417 17.433 24.692 16.7827 24.692 15.9805C24.692 15.1783 24.0417 14.528 23.2395 14.528Z",
    fill: "currentcolor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCirclePlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circlePlus.ac9051c12828d3b38d90ec034dac6176.svg";